<div class="uploadFiles"
     [ngClass]="{'uploadDisabled': !moreThanOneFile && getNumberOfFiles()>0,'upload-not-valid': !uploadIsValid(),'upload-valid': uploadIsValid()}">
    <!--Title of category-->
    <h3>{{filesTitle}}</h3>
    <!--Select window-->
    <p-fileUpload #fileUpload [chooseLabel]="'UPLOAD_COMPONENT.ADD_FILES_BUTTON_LABEL' | translate"
                  [cancelLabel]="'UPLOAD_COMPONENT.CANCEL_BUTTON_LABEL' | translate"
                  [multiple]="moreThanOneFile"
                  [accept]="formatExtensionsForRestrictions()"
                  [customUpload]="true"
                  [showUploadButton]="false"
                  [disabled]="isDisabled()"
                  (onSelect)="handleAddingFiles($event)"
                  (onClear)="clearFiles()">
        <!--Select window body-->

        <!--Files templating-->
        <ng-template let-file let-i="index" pTemplate="file">
            <!--File Name-->
            <div class="grid">
                <div class="principalFileReceiver col-9">
                    {{file.name}}
                </div>
                <!--File Action-->
                <div class="col-3">
                    <button type="button" [icon]="'fa fa-close'" pButton (click)="removeFile(i)"></button>
                    <button type="button" [icon]="'fa fa-arrow-up'" pButton [disabled]=!moveUpIsPossible(i)
                            (click)="moveUpFile(i)"></button>
                    <button type="button" [icon]="'fa fa-arrow-down'" pButton [disabled]=!moveDownIsPossible(i)
                            (click)="moveDownFile(i)"></button>
                </div>
            </div>
        </ng-template>
        <!--Message on the body of the selection window-->
        <ng-template pTemplate="content" let-files>
            <!--<div *ngIf="displayDropZone" class="grid drop-container">
              <i class="fa fa-tint" aria-hidden="true"></i>
            </div>-->
            <hr>
            <div class="grid aa">
                <div class="col-12 bb">
                    <!--No files selected yet case-->
                    <div *ngIf="getNumberOfFiles()==0">
                        <!--check if it's mandatory to have files-->
                        <div *ngIf="!optional">
                            <!--Message to ask for multiple files-->
                            <p *ngIf="moreThanOneFile">{{ 'FILES.UPLOAD_COMPONENT.HELP_MESSAGE.MANDATORY_AT_LEAST_ONE' |
                                translate}}: {{formatExtensionsForMessage()}}</p>
                            <!--Message to ask for a single file-->
                            <p *ngIf="!moreThanOneFile">{{ 'FILES.UPLOAD_COMPONENT.HELP_MESSAGE.MANDATORY_EXACTLY_ONE' |
                                translate}}: {{formatExtensionsForMessage()}}</p>
                        </div>
                        <!--check if it's not mandatory to have files-->
                        <div *ngIf="optional">
                            <!--Message to ask for multiple files-->
                            <p *ngIf="moreThanOneFile">{{ 'FILES.UPLOAD_COMPONENT.HELP_MESSAGE.OPTIONAL_AT_LEAST_ONE' |
                                translate }}: {{formatExtensionsForMessage()}}</p>
                            <!--Message to ask for a single file-->
                            <p *ngIf="!moreThanOneFile">{{ 'FILES.UPLOAD_COMPONENT.HELP_MESSAGE.OPTIONAL_EXACTLY_ONE' |
                                translate }}: {{formatExtensionsForMessage()}}</p>
                        </div>
                    </div>
                    <!--Already selected files case-->
                    <div *ngIf="getNumberOfFiles()>0">
                        <!-- 0-n files accepted: so it's necessary ok-->
                        <p *ngIf="moreThanOneFile">{{ 'FILES.UPLOAD_COMPONENT.HELP_MESSAGE.DEPOSIT_VALID' |
                            translate }} :{{formatExtensionsForMessage()}}</p>
                        <!-- 1 file accepted and 1 already selected-->
                        <p *ngIf="!moreThanOneFile && !tooMuchFileOnSelection()">{{
                            'FILES.UPLOAD_COMPONENT.HELP_MESSAGE.DEPOSIT_FULL_VALID' | translate }}</p>
                        <!-- 1 file accepted and more than 1 already selected-->
                        <p *ngIf="!moreThanOneFile && tooMuchFileOnSelection()">{{
                            'FILES.UPLOAD_COMPONENT.HELP_MESSAGE.DEPOSIT_TOO_MUCH_FILE' |
                                translate }}: {{formatExtensionsForMessage()}}</p>
                    </div>


                </div>

            </div>
        </ng-template>
</p-fileUpload>

</div>

